<template>
  <div class="configurationList">
    <div class="configurationList_selectionArea">
      <div class="box-wrap">
        <el-input
          v-model="parameter.equipment_code"
          placeholder="请输入Android ID"
          style="width: 200px; "
        />
        <el-input
          v-model="parameter.phone_name"
          placeholder="请输入设备名称"
          style="width: 200px; "
        />
        <el-select
          v-model="parameter.login_type"
          placeholder="请选择手机类型"
          style=""
        >
          <el-option
            v-for="item in optionsphone"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          />
        </el-select>
        <el-select
          v-model="parameter.only_me"
          placeholder="请选择"
          style=""
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="search"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh-right"
          @click="reset"
        >重置</el-button>
      </div>
      <div>
        <el-button
          type="success"
          icon="el-icon-plus"
          @click="add"
        >创建</el-button>
      </div>
    </div>
    <div
      style="
        margin-top: 20px;
        color: rgb(169, 162, 151);
        display: flex;
        align-items: center;
      "
    >
      <div>手机链接数：</div>
      <div>
        <el-tag>{{ online_count }}</el-tag>
      </div>
    </div>
    <div class="configurationList_main">
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" align="center" min-width="50" />
        <el-table-column
          prop="login_type_text"
          label="手机类型"
          align="center"
          min-width="100"
        />
        <el-table-column
          prop="equipment_code"
          label="Android ID"
          align="center"
          min-width="120"
        >
          <template #default="{ row }">
            <span class="copyable" @click="copyText(row.equipment_code)">
              {{ row.equipment_code }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="phone_name"
          label="设备名称"
          align="center"
          min-width="120"
        />
        <el-table-column
          prop="instance_name"
          label="云手机实例ID"
          align="center"
          min-width="140"
        >
          <template #default="{ row }">
            <span
              class="copyable"
              :class="{ unbound: !row.instance_name }"
              @click="row.instance_name && copyText(row.instance_name)"
            >
              {{ row.instance_name || '暂未绑定' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="version_num"
          label="软件版本"
          align="center"
          min-width="80"
        />
        <el-table-column
          prop="ww_version"
          label="企微版本"
          align="center"
          min-width="80"
        />
        <el-table-column
          prop="login_status_text"
          label="登陆状态"
          align="center"
          min-width="80"
        />
        <el-table-column
          prop="connection_status"
          label="链接状态"
          align="center"
          min-width="80"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.connection_status === 1"
            ><i class="el-icon-error err" />断开链接</span>
            <span
              v-else-if="scope.row.connection_status === 2"
            ><i class="el-icon-success normal" />链接中</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="admin_name"
          label="创建人"
          align="center"
          min-width="80"
        />
        <el-table-column
          prop="last_connection_time_text"
          label="最后心跳时间"
          align="center"
          min-width="100"
        />
        <el-table-column
          prop="status"
          label="状态"
          align="center"
          min-width="80"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.status === 1"
            ><i class="el-icon-success normal" />正常</span>
            <span
              v-else-if="scope.row.status === 2"
            ><i class="el-icon-error err" />停用</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="操作"
          min-width="250"
          align="center"
        >
          <template slot-scope="scope">
            <div class="btn-wrap-box">
              <el-button
                type="warning"
                size="mini"
                @click="modifyItem(scope.row)"
              >修改</el-button>
              <el-button
                type="danger"
                size="mini"
                @click="deleteItem(scope.row)"
              >删除</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="
                  relevance(
                    scope.row.id,
                    scope.row.login_type,
                    scope.row.login_status,
                    scope.row.equipment_code
                  )
                "
              >关联企业员工</el-button>
              <!-- 当手机类型为“阿里云”时，显示“连接云手机窗口”按钮 -->
              <el-button
                v-if="scope.row.login_type === 4"
                type="success"
                size="mini"
                @click="openAliyunDialog(scope.row)"
              >
                连接
              </el-button>
              <!-- 当手机类型为“腾讯云”时，显示“连接云手机窗口”按钮 -->
              <el-button
                v-if="scope.row.login_type === 3"
                type="success"
                size="mini"
                @click="openTencentDialog(scope.row)"
              >
                连接
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <PaginationRight
        :total="tableData.total"
        :page-sizes="[10]"
        :current-page="parameter.page"
        @size-change="fetchPageSizeone"
        @current-change="fetchCurrentPageone"
      />
    </div>

    <el-dialog
      :title="Object.keys(currentItem).length ? '修改' : '创建'"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <Details
        v-if="dialogVisible"
        ref="detailsview"
        :current-item="currentItem"
        @determine="determine"
        @close="dialogVisible = false"
      />
    </el-dialog>
    <el-dialog
      title="关联企业员工"
      :visible.sync="relevanceVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      class="popup-mid"
    >
      <relevancedialog ref="relevanceVisibleview" @updata="updata" />
    </el-dialog>
    <!-- 阿里云手机 弹窗组件 -->
    <cloud-mobile-dialog
      v-if="mobileDialogVisible"
      :visible.sync="mobileDialogVisible"
      :connection-params="mobileConnectionParams"
    />
    <!-- 腾讯云手机 弹窗组件 -->
    <tencent-cloud-mobile-dialog
      :visible.sync="tencentDialogVisible"
      :connection-params="tencentConnectionParams"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight'
import Details from './components/details.vue'
import relevancedialog from './components/relevancedialog.vue'
import CloudMobileDialog from './components/CloudMobileDialog.vue'
import TencentCloudMobileDialog from './components/TencentCloudMobileDialog.vue'
import {
  weworkPhoneList,
  weworkPhoneDelete,
  weworkPhoneModification,
  weworkPhoneAddition,
  phonelist,
  getAliTicket
} from '@/api/enterprisewechatControl'
// import { connectWebsocket } from '../../utils/webSocket'
// import yun from './components/yun.vue'
export default {
  name: 'WeworkPhoneList',
  components: {
    PaginationRight,
    Details,
    relevancedialog,
    CloudMobileDialog,
    TencentCloudMobileDialog
  },
  data() {
    return {
      parameter: {
        equipment_code: null, // Android ID
        phone_name: null, // 设备名称
        page: 1,
        page_size: 10,
        only_me: 1,
        login_type: ''
      },
      options: [
        {
          value: 1,
          label: '组内手机'
        },
        {
          value: 2,
          label: '我的手机'
        }
      ],
      tableData: {},
      loading: false,
      currentItem: {},
      dialogVisible: false,
      relevanceVisible: false,
      lookVisible: false,
      online_count: 0,
      optionsphone: [],
      mobileDialogVisible: false,
      mobileConnectionParams: {},
      tencentDialogVisible: false,
      tencentConnectionParams: {}
    }
  },
  created() {
    this.getList()
    this.phonelistall()
  },
  activated() {
    this.getList()
    this.phonelistall()
  },
  // mounted() {
  //   console.log('mounted',process.env.VUE_APP_BACKUPSOCKET_API_URL)
  //   const that = this
  //   connectWebsocket(
  //     // 测试地址
  //     process.env.VUE_APP_BACKUPSOCKET_API_URL,
  //     // 传递给后台的数据
  //     // 'openexe',
  //     { type: 'web_init' },
  //     // 成功拿到后台返回的数据的回调函数
  //     data => {
  //       console.log('成功的回调函数, 接收到的data数据: ', JSON.parse(data))
  //       if (JSON.parse(data).type === 'unconnect') {
  //         // that.$notify.info({
  //         //   title: '消息',
  //         //   message: `${JSON.parse(data).data.msg}`,
  //         //   duration: 300000
  //         // })
  //         if (that.online_count != 0) {
  //           that.online_count--
  //         }
  //       }
  //       if (JSON.parse(data).type === 'connect') {
  //         that.online_count++
  //       }
  //     },
  //     // websocket连接失败的回调函数
  //     err => {
  //       console.log('失败的回调函数', err)
  //     }
  //   )
  // },
  methods: {
    async getList() {
      this.loading = true
      const data = await weworkPhoneList(this.parameter)
      this.tableData = data.data
      this.online_count = data.data.online_count
      this.loading = false
    },
    phonelistall() {
      phonelist().then((res) => {
        this.optionsphone = res.data
      })
    },
    // 删除
    async deleteItem(row) {
      this.$confirm('是否确定删除该手机信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        await weworkPhoneDelete({ id: row.id })
        this.getList()
        this.$message({
          message: '删除成功',
          type: 'success'
        })
      })
    },

    // 修改
    modifyItem(row) {
      this.currentItem = row
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.detailsview.send(2)
      })
    },
    add() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.detailsview.send(1)
      })
    },
    // 搜索
    search() {
      this.parameter.page = 1
      this.parameter.page_size = 10
      this.getList()
    },

    // 重置
    reset() {
      this.parameter.page = 1
      this.parameter.page_size = 10
      this.parameter.equipment_code = null
      this.parameter.login_type = ''
      this.parameter.phone_name = null
      this.parameter.only_me = 1
      this.getList()
    },

    // 关联企业员工
    relevance(id, login_type, login_status, pod_id) {
      this.relevanceVisible = true
      this.$nextTick(() => {
        this.$refs.relevanceVisibleview.send(
          id,
          login_type,
          login_status,
          pod_id
        )
      })
    },
    updata() {
      this.relevanceVisible = false
      this.getList()
    },

    // 确定
    async determine(form) {
      const bool = !!Object.keys(this.currentItem).length
      bool
        ? await weworkPhoneModification({ id: this.currentItem.id, ...form })
        : await weworkPhoneAddition(form)
      this.currentItem = {}
      this.dialogVisible = false
      this.getList()
      this.$message({
        message: bool ? '修改成功' : '创建成功',
        type: 'success'
      })
    },

    // 关闭
    handleClose(done) {
      this.dialogVisible = false
      this.currentItem = {}
    },

    fetchPageSizeone(e) {
      this.parameter.page_size = e
      this.getList()
    },

    fetchCurrentPageone(e) {
      this.parameter.page = e
      this.getList()
    },
    // 连接阿里云手机
    async openAliyunDialog(row) {
      // 1. 取当前行设备编码
      const instance_id = row.instance_sign_id
      try {
        // 2. GET 请求获取 ticket，axios 会把 { equipment_code } 作为查询参数
        const res = await getAliTicket({ instance_id })
        const {
          ticket,
          desktop_id: desktopId,
          real_desktop_id: realDesktopId,
          region_id: regionId
        } = res.data

        if (!ticket || !desktopId || !realDesktopId || !regionId) {
          this.$message.warning(
            '接口返回参数不完整，请检查 ticket、desktop_id、real_desktop_id、region_id'
          )
          return
        }

        // 3. 拿到 ticket 后再构造连接参数
        // 3. 构造云桌面连接参数
        this.mobileConnectionParams = {
          ticket,
          desktopInfo: {
            desktopId,
            desktopName: '',
            realDesktopId,
            protocolType: 'ASP',
            loginRegionId: regionId,
            connConfig: { decodeType: 0 }
          },
          regionId,
          openType: 'inline',
          resourceType: 'local'
        }

        // 4. 打开弹窗
        this.mobileDialogVisible = true
      } catch (err) {
        console.error('获取 ticket 失败：', err)
        this.$message.error('获取连接凭证失败，请重试')
      }
    },
    // 连接腾讯云手机
    async openTencentDialog(row) {
      if (row.instance_name === '') {
        this.$message.error('请先绑定云手机实例ID')
      } else {
        this.tencentConnectionParams = { sn: row.instance_name }
        this.tencentDialogVisible = true
      }
    },
    copyText(text) {
      if (!text) return
      // 优先异步 Clipboard API
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(text)
          .then(() => this.$message.success(`已复制: ${text}`))
          .catch(() => this.fallbackCopy(text))
      } else {
        this.fallbackCopy(text)
      }
    },
    fallbackCopy(text) {
      const ta = document.createElement('textarea')
      ta.value = text
      ta.setAttribute('readonly', '')
      ta.style.position = 'absolute'
      ta.style.left = '-9999px'
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
        this.$message.success(`已复制: ${text}`)
      } catch {
        this.$message.error('复制失败，请手动选择复制')
      }
      document.body.removeChild(ta)
    }
  }
}
</script>

<style scoped>
.configurationList {
  width: 95%;
  margin: 0 auto;
  margin-top: 30px;
}

.configurationList_selectionArea {
  display: flex;
  justify-content: space-between;
}

.configurationList_main {
  margin-top: 20px;
}

.err {
  color: #caae24;
  font-size: 14px;
  margin-right: 6px;
}

.normal {
  color: #5fc922;
  font-size: 16px;
  margin-right: 6px;
}
.copyable {
  cursor: pointer;
  transition: all 0.3s;
}
.copyable:hover {
  color: #165dff;
}
.copyable:hover {
  text-decoration: underline;
}
/* 未绑定时灰色，并且不显示 hover 效果 */
.copyable.unbound {
  color: #999;
  cursor: default;
  text-decoration: none;
}
.box-wrap{
  display:flex;
  flex-wrap:wrap;
  gap:10px;
}
</style>
